export const environment = {
  production: true,
  fallbackLocale: 'pt-PT',
  tenant: 'activities_PRT',
  widget: false,
  serviceWorker: {
    enable: true,
  },
  e2e: {
    // enable e2e mode with data-test markup
    enable: false,
  },
  applications: {
    datadog: {
      applicationId: 'f2062e7c-738c-4e68-80c7-431aede71afb',
      clientToken: 'pub479f0afae0f5f45fa57ee25866064036',
    },
    cdn: {
      host: 'https://activities-assets.decathlon.net/legacy',
      root: 'https://activities-assets.decathlon.net',
    },
    phrase: {
      locales: {
        'pt-PT': 'b6737465eb6a836c1424e951df915113',
      },
    },
    front: {
      url: 'https://desporto.decathlon.pt',
      domain: 'desporto.decathlon.pt',
    },
    woosmap: {
      apiKey: 'woos-6e588fc5-a1e3-3d39-9ee1-28b713fdd5df',
      gmapApiKey: 'AIzaSyDG3jq0cm9JoLe9E8PCAZaawAHrfQ7U_ss',
      locale: 'country:pt',
    },
    amplitude: {
      apiKey: 'c06224e8147966f6ffae12a7f2d7d198',
    },
    gtm: {
      id: 'GTM-MTM3WV9',
    },
    sentry: {
      dsn: 'https://0fc1729944bc4fa1a21e1cab26bd34ad@sentry.io/1396593',
      environment: 'production-PRT',
      enabled: true
    },
    talkjs: {
      appId: 'QFqHH3hk'
    },
    activities: {
      url: 'https://api-eu.decathlon.net/activities/v2',
      api_key: '29b3feaf-a8f1-4ccf-97bf-da3cfd34141e',
    },
    strapi: {
      url: 'https://desporto.decathlon.pt/strapi-api',
      locale: '',
    },
    stripe: {
      apiKey: 'pk_live_51HugXdCmehpkCdV3TAW8XgtcfdcqBx0iDM5MRIn2WJo6wkH9GbbuN2Lfmu3wGFoOn4HC0bwGskPLEc5kr56CenKk00357Bpo6y',
      authorizeUri: 'https://connect.stripe.com/express/oauth/authorize',
      apiUrl: 'https://connect.stripe.com',
    },
    pfs: {
      url: 'https://europe-west1-services-platform-pwlg.cloudfunctions.net/api'
    },
    advice: {
      url: 'https://api-global.decathlon.net/cms',
      apiKey: 'c1bd69cf-9822-49be-819a-a42dd47cb043',
    },
    reviews: {
      url: 'https://reviews.decathlon.com',
    },
    onepay: {
      host: 'https://onepay-widget.decathlon.net',
    },
  },
  auth: {
    fed: {
      issuer: 'https://idpdecathlon.oxylane.com',
      redirectUri: 'https://desporto.decathlon.pt/auth/redirection',
      clientId: 'Cc73544e2464f2bbb5585c8508f0d4ceba0afa720',
      userinfoEndpoint:
        'https://idpdecathlon.oxylane.com/idp/userinfo.openid',
      discoveryDocument:
        'https://idpdecathlon.oxylane.com/.well-known/openid-configuration',
    },
    connect: {
      issuer: 'https://api-eu.decathlon.net/connect',
      redirectUri: 'https://desporto.decathlon.pt/auth/redirection',
      clientId: 'd7be5a70-104d-4691-8f5e-13db333b0e4c',
      discoveryDocument:
        'https://api-global.decathlon.net/connect/.well-known/openid-configuration',
      logoutRedirectionUrl: 'https://desporto.decathlon.pt/auth/logout',
    },
  },
};
